import { useMutation } from "@tanstack/react-query"

import { client } from "@/api"
import { EditEventFormDataType } from "@/dialogs/events/EditEventDialog"

function useEditEvent(eventId: number) {
  return useMutation({
    mutationFn: (data: EditEventFormDataType) => {
      return client
        .put(`/events/${eventId}`, data)
        .then((response) => response.data)
    },
  })
}
export default useEditEvent
